import React from 'react'
import styles from './styles.module.scss'
import { checkStoreIs } from '@helpers/env'

type CartTotalProps = {
  total: string
  isFreeDelivery?: boolean
}

const CardTotal = ({ total = '0.00', isFreeDelivery }: CartTotalProps) => (
  <div className={styles.CardTotal} data-testid="cart-total">
    {isFreeDelivery && !checkStoreIs('us') && (
      <div
        className={`${styles.CardTotal__line} ${styles.CardTotal__lineDelivery}`}
      >
        <p className={styles.CardTotal__title}>Delivery</p>
        <p className={styles.CardTotal__price}>Free</p>
      </div>
    )}
    <div className={styles.CardTotal__line}>
      <p className={styles.CardTotal__title}>Subtotal</p>
      <p className={`${styles.CardTotal__price} cart-basket-subtotal`}>
        {total}
      </p>
    </div>
  </div>
)

export default CardTotal
